import { RemixBrowser } from '@remix-run/react'
import posthog from 'posthog-js'
import { startTransition, useEffect } from 'react'
import { hydrateRoot } from 'react-dom/client'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

function PosthogInit() {
	useEffect(() => {
		posthog.init('phc_k5ImiLjcC1cOTJGUalFDdDJFHYKnp4X7J9xHEYsW9qH', {
			api_host: 'https://eu.posthog.com',
		})
	}, [])

	return null
}

startTransition(() => {
	hydrateRoot(
		document,
		<>
			<RemixBrowser />
			<PosthogInit />
		</>,
	)
})
